<app-cookies-modal #modal [modalConfig]="modalConfig">
</app-cookies-modal>

<div *ngIf="cookieBottomMsgVisible" id="cookiesad" class="js-cookie-consent cookie-consent">
  <div class="container">
    <span class="cookie-consent__message">
      <div class="title">
        <h3 class="fw-bold">Configuración de cookies</h3>
      </div>
      <p class="cookie-consent__message">Para RetailCo es importante adaptarse a tus gustos y preferencias, para ello
        usamos cookies propias y de terceros que nos permiten medir el volumen y la interacción de los usuarios en la
        web y nos ayudan a mejorarla, permitiéndonos analizar tus hábitos y elaborar perfiles de navegación, respetando
        en todo caso tu privacidad. Puedes configurar las cookies o aceptarlas todas. Este banner se mantendrá activo
        hasta que ejecutes una de las dos opciones. Para más información consulta nuestra
        <a routerLink="/cookies/">Política de Cookies</a>.
      </p>
      <div class="box-button">
        <div class="box-left">
          <button type="button" id="button" class="btn-rco-cookies" (click)="openModal()">Configurar cookies</button>
          <!-- <div class="info"><i class="fa fa-clock-o"></i> Solo te llevará unos segundos
                  </div> -->
          &nbsp;&nbsp;
          <button (click)="RejectAllCookies()" id="button" class="btn-rco-cookies">Rechazar todas las cookies</button>
        </div>

        <div class="box-right"> <button (click)="AcceptAllCookies()">
            Aceptar todas las cookies
          </button> </div>
      </div>
    </span>
  </div>
</div>

<!-- footer start -->
<footer class="footer bg-dark" *ngIf="!isInmuebles">
  <!-- container start -->
  <div class="container">

    <div class="footer-top">
      <!-- row start -->
      <div class="row y-gap-48 justify-content-between">

        <div class="col-lg-3 col-sm-12">

          <a class="logo"><img src="assets/img/logo.svg" alt="Logo RetailCo" width="180" /></a>

        </div>

        <div class="col-lg-3 col-sm-12 mt-lg-0 mt-4">

          <a routerLink="/aviso-legal/">Aviso Legal</a>
          <a routerLink="/cookies/">Política de cookies</a>
          <a routerLink="/proteccion-datos/">Política de protección de datos</a>
          <a routerLink="/accesibilidad/">Accesibilidad</a>

        </div>


        <div class="col-lg-2 col-sm-12">

          <div>
            <a href="https://es.linkedin.com/company/retailco-gruposantander" target="_blank"
              rel="noreferrer noopener">Linkedin</a>
          </div>

        </div>

        <div class="col-lg-2 col-sm-12">

          <a href="mailto:comercial@retailco.es" target="_blank">comercial&#64;retailco.es</a>

        </div>

        <div class="col-lg-2 col-sm-12 mt-lg-0 mt-4">

          <a class="logo"><img src="assets/img/logo_footer.svg" alt="Logo Grupo Santander" width="150" /></a>

        </div>


      </div>
      <!-- row end -->
    </div>


    <div class="footer-bottom mt-5">
      <!-- row start -->
      <div class="row">
        <div class="col">
          <div class="footer__copyright">
            <p class="pt-4">
              &#64; 2025, RetailCo. Todos los derechos reservados.
              <span class="black"> - v250701</span>
            </p>
          </div>
        </div>
      </div>
      <!-- row end -->
    </div>

  </div>
  <!-- container end -->
</footer>
<!-- footer end -->